import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import MuiList from "@mui/material/List";
import TriggerMenuItem from "layouts/Flow Designer/components/TriggerMenuItem";
import triggers from "layouts/Flow Designer/schemas/triggers";
import ToolboxDetailHeader from "../ToolboxDetailHeader";
import ToolboxDetailSubHeader from "../ToolboxDetailSubHeader";
import { useDetermineShareFlowUserAccessType } from "hooks/useDetermineShareFlowUserAccessType";
import { TRIGGER_TYPES } from "constants/flowDesigner";
import useAllowEditWorkflow from "hooks/useAllowEditWorkflow";
TriggerMenuItem
const List = styled(MuiList)(({ theme }) => ({
  overflow: "hidden",
  overflowY: "auto",
  maxHeight: "500px",
  minHeight: "141px",

  scrollbarWidth: "thin", // Firefox
  scrollbarColor: `${theme.palette.grey[400]} transparent`,

  "&::-webkit-scrollbar": {
    width: "8px",
    background: "transparent",
    transition: "opacity 0.2s",
    opacity: 0
  },
  "&:hover::-webkit-scrollbar": {
    opacity: 1
  },
  "&::-webkit-scrollbar-thumb": {
    background: theme.palette.grey[400],
    borderRadius: "8px"
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent"
  }
}));

const customStyles = {
  fontSize: "22px",
  minWidth: "40px"
};

const TriggersList = () => {
  const { t } = useTranslation("flowDesigner");
  const { currentSavedFlow } = useSelector((state) => state.designer.flows);
  const { isReadOnlyAccess } = useDetermineShareFlowUserAccessType(currentSavedFlow?.id);
  const { allowEditWorkflow } = useAllowEditWorkflow();

  const isTriggerActive = (trigger) => {
    if (trigger.type === TRIGGER_TYPES.BLUE_PRISM_DELTA) {
      return false;
    }

    return true;
  };

  return (
    <Box py={2} pl={2} pr={2} sx={{ flexGrow: 1 }}>
      <ToolboxDetailHeader title={t("toolbox.headers.triggers")} />
      <ToolboxDetailSubHeader
        title={t("toolbox.titles.library")}
        subtitle={t("toolbox.subtitles.library_triggers")}
      />
      <List sx={{ width: 305 }}>
        {triggers
          ?.filter(isTriggerActive)
          .sortAlphabetical("label")
          .map((trigger) => (
            <TriggerMenuItem
              key={trigger.type}
              trigger={trigger}
              customStyles={customStyles}
              allowDescription
              allowEditWorkflow={allowEditWorkflow(isReadOnlyAccess)}
            />
          ))}
      </List>
    </Box>
  );
};

export default TriggersList;